import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from 'axios';
import css from './index.module.css';

import SEO from "@components/seo";
import MainContent from "@components/content";

import { useTranslation } from 'react-i18next';
import { toast } from "sonner";
import useUserData from "@hooks/useUserData";

export default function CreateContainer() {
    const { t } = useTranslation();
    let { id } = useParams();
    const [step, setStep] = useState(1);
    const navigate = useNavigate();
    const [domain, setDomain] = useState<string>('');
    const [domainPre, setDomainPre] = useState<string>('');
    const [isValid, setIsValid] = useState<boolean>(true);
    const [isValidPre, setIsValidPre] = useState<boolean>(true);
    const [city, setCity] = useState<string>('ru-0');
    const [tariff, setTariff] = useState<number>(0);
    const [payment, setPayment] = useState<number>(1);
    const { userData } = useUserData();

    const domainPattern = /^(?!http:\/\/|https:\/\/)([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;
  
    const handleChangeDomain = (e: any) => {
      const value = e.target.value;
      setDomain(value);
  
      if (domainPattern.test(value)) {
        setIsValid(true);
      } else {
        setIsValid(false);
      }
    };

    const handleChangePre = (e: any) => {
        const value = e.target.value;
        setDomainPre(value);
    
        if (domainPattern.test(value)) {
            setIsValidPre(true);
        } else {
            setIsValidPre(false);
        }
    };

    function handleStep (event: any) {
        event.preventDefault();

        const formData = new FormData(event.target);
        formData.append('city', city);
        formData.append('tariff', tariff.toString());
        formData.append('period', payment.toString());

        // @ts-ignore
        window.dataLayer = window.dataLayer || [];
        // @ts-ignore
        window.dataLayer.push({'event':'purchase',
            'userID': userData?.id,
            'step': 1,
            'tariff': tariff.toString(),
            'city': city
        });

        axios.post(`${import.meta.env.VITE_API_URL}/gtm/create`, formData, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('authToken')
        }})
        .then(response => {
            toast.success(t('gtm.on'));
            event.target.reset();
            navigate(`/container/${response.data.uuid}`);
        }).catch(error => {
            toast.error(t('gtm.errFounds'));
        }) 
    }

    function calculatePrice () {
        let price = 2500;
        
        if (tariff === 0) price = 2500;
        if (tariff === 1) price = 5000;
        if (tariff === 2) price = 10000;

        if (city === 'nl-0') price += 300;

        let discount = 0;
        if (payment === 3) discount = 0.05;
        if (payment === 6) discount = 0.08;
        if (payment === 12) discount = 0.12;

        const finalPrice = Math.round(price * (1 - discount));
        return finalPrice;
    }

    function calculateTotal() {
        const price: any = calculatePrice();
        const total = parseInt(price) * payment;
        return total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }

    return (
        <MainContent>    
            <SEO 
                title="Создать контейнер"
                description=""
                ogUrl="https://artcons.io/"
            />

            <div className={css.head}>
                <Link to={`/`} className={css.back}><i className="fi fi-rr-arrow-small-left"></i> Вернуться</Link>
                <h1>Создать контейнер</h1>
            </div>

            <div className={css.steps}>
                <div className={step == 1 ? css.stepActive : step > 1 ? css.stepSuccess : css.step}>
                    <a>{t('gtm.step')} 1</a>
                </div>
                <div className={step == 2 ? css.stepActive : step > 2 ? css.stepSuccess : css.step}>
                    <a>{t('gtm.step')} 2</a>
                </div>
                <div className={step == 3 ? css.stepActive : step > 3 ? css.stepSuccess : css.step}>
                    <a>{t('gtm.step')} 3</a>
                </div>
            </div>        

            <div className={css.information}>
                <div className={css.icon}>
                    <i className="fi fi-rr-search"></i>
                </div>
                
                <div className={css.text}>
                    <b>Пожалуйста, вводите данные внимательно</b>
                    <a>После создания контейнера изменения будут невозможны. Убедитесь, что все данные указаны правильно. <a style={{ color: "#1057e4" }} href="https://artcons.io/blog/4" target="_blank">Как создать контейнер?</a></a>
                </div>
            </div>

            <form className={css.form} onSubmit={handleStep}>
                <div className={css.inputBlock}>
                    <label style={{fontSize: "14px",color: "var(--text-color)",marginTop: "0px"}}>{t('gtm.name')}</label>
                    <input placeholder={t('gtm.name')} name="name" required/>
                </div>

                <div className={css.inputBlock}>
                    <label style={{fontSize: "14px",color: "var(--text-color)",marginTop: "0px"}}>{t('gtm.domain')}</label>
                    <input placeholder={t('gtm.domainExample')} value={domain} onChange={handleChangeDomain}  name="domain" required/>
                    {!isValid && ( <a style={{ color: '#ff9595', fontSize: 13, margin: 0, marginBottom: 10 }}>Неверный формат домена. Пример: gtm.artcons.io (без http/https).</a> )}
                </div>

                <div className={css.inputBlock}>
                    <label style={{fontSize: "14px",color: "var(--text-color)",marginTop: "0px"}}>{t('gtm.domainPre')}</label>
                    <input placeholder={t('gtm.domainPreExample')} value={domainPre} onChange={handleChangePre}  name="domainPre" required/>
                    {!isValidPre && ( <a style={{ color: '#ff9595', fontSize: 13, margin: 0, marginBottom: 10 }}>Неверный формат домена. Пример: gtm.artcons.io (без http/https).</a> )}
                </div>
                
                <div className={css.inputBlock}>
                    <label style={{fontSize: "14px",color: "var(--text-color)",marginTop: "0px"}}>{t('gtm.token')}</label>
                    <input placeholder={t('gtm.tokenExample')} name="token" required/>
                </div>

                <div className={css.inputBlock} style={{ marginTop: 5 }}>
                    <label style={{fontSize: "14px",color: "var(--text-color)",marginTop: "0px"}}>{t('gtm.tariff')}</label>
                    <div className={css.selector}>                                
                        <div className={`${tariff === 0 && css.active}`} onClick={() => setTariff(0)}>Базовый — 2 500 ₽/мес</div>
                        <div className={`${tariff === 1 && css.active}`} onClick={() => setTariff(1)}>Стандарт — 5 000 ₽/мес</div>
                        <div className={`${tariff === 2 && css.active}`} onClick={() => setTariff(2)}>Бизнес — 10 000 ₽/мес</div>
                        <div onClick={() => navigate('/support')}>Крупный бизнес — по запросу</div>
                    </div>
                </div>

                <div className={css.inputBlock} style={{ marginTop: 5 }}>
                    <label style={{fontSize: "14px",color: "var(--text-color)",marginTop: "0px"}}>Период оплаты контейнера</label>
                    <div className={css.selector}>                                
                        <div className={`${payment === 1 && css.active}`} onClick={() => setPayment(1)}>Оплатить на месяц</div>
                        <div style={{ justifyContent: 'start', paddingLeft: 15 }} className={`${payment === 3 && css.active}`} onClick={() => setPayment(3)}>Оплатить на 3 месяца <b className={css.discount}><i className="fi fi-rr-badge-percent" /> 5% скидка</b></div>
                        <div style={{ justifyContent: 'start', paddingLeft: 15 }} className={`${payment === 6 && css.active}`} onClick={() => setPayment(6)}>Оплатить на 6 месяцев <b className={css.discount}><i className="fi fi-rr-badge-percent" /> 8% скидка</b></div>
                        <div style={{ justifyContent: 'start', paddingLeft: 15 }} className={`${payment === 12 && css.active}`} onClick={() => setPayment(12)}>Оплатить на 12 месяцев <b className={css.discount}><i className="fi fi-rr-badge-percent" /> 12% скидка</b></div>
                    </div>
                </div>

                <div className={css.inputBlock}>
                    <label style={{fontSize: "14px",color: "var(--text-color)",marginTop: "5px"}}>{t('gtm.city')}</label>
                    <div className={css.selector}>                                
                        <div className={`${city === 'ru-0' && css.active}`} onClick={() => setCity('ru-0')}><svg width="20" height="20" style={{ position: 'relative', top: '-1px' }} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className="Card__icon--oD5pH"><g clip-path="url(#russia_flag_svg__a)"><mask id="russia_flag_svg__b" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32"><path d="M16 32a16 16 0 1 0 0-32 16 16 0 0 0 0 32Z" fill="#fff"></path></mask><g mask="url(#russia_flag_svg__b)"><path d="m0 10.44 15.86-1.21L32 10.43v11.13l-15.93 2.02L0 21.56V10.44Z" fill="#0052B4"></path><path d="M0 0h32v10.44H0V0Z" fill="#fff"></path><path d="M0 21.56h32V32H0V21.56Z" fill="#D80027"></path></g></g><rect x="0.25" y="0.25" width="31.5" height="31.5" rx="15.75" stroke="#000" stroke-opacity="0.1" stroke-width="0.5"></rect><defs><clipPath id="russia_flag_svg__a"><rect width="32" height="32" rx="16" fill="#fff"></rect></clipPath></defs></svg> Россия (Санкт-Петербург)</div>
                        <div className={`${city === 'ru-1' && css.active}`} onClick={() => setCity('ru-1')}><svg width="20" height="20" style={{ position: 'relative', top: '-1px' }} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className="Card__icon--oD5pH"><g clip-path="url(#russia_flag_svg__a)"><mask id="russia_flag_svg__b" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32"><path d="M16 32a16 16 0 1 0 0-32 16 16 0 0 0 0 32Z" fill="#fff"></path></mask><g mask="url(#russia_flag_svg__b)"><path d="m0 10.44 15.86-1.21L32 10.43v11.13l-15.93 2.02L0 21.56V10.44Z" fill="#0052B4"></path><path d="M0 0h32v10.44H0V0Z" fill="#fff"></path><path d="M0 21.56h32V32H0V21.56Z" fill="#D80027"></path></g></g><rect x="0.25" y="0.25" width="31.5" height="31.5" rx="15.75" stroke="#000" stroke-opacity="0.1" stroke-width="0.5"></rect><defs><clipPath id="russia_flag_svg__a"><rect width="32" height="32" rx="16" fill="#fff"></rect></clipPath></defs></svg> Россия (Москва)</div>
                        <div className={`${city === 'nl-0' && css.active}`} onClick={() => setCity('nl-0')}><svg width="20" height="20" style={{ position: 'relative', top: '-1px' }} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className="Card__icon--oD5pH"><g clip-path="url(#netherlands_flag_svg__a)"><mask id="netherlands_flag_svg__b" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32"><path d="M16 32a16 16 0 1 0 0-32 16 16 0 0 0 0 32Z" fill="#fff"></path></mask><g mask="url(#netherlands_flag_svg__b)"><path d="m0 10.44 15.86-1.21L32 10.43v11.13l-15.93 2.02L0 21.56V10.44Z" fill="#fff"></path><path d="M0 0h32v10.44H0V0Z" fill="#A2001D"></path><path d="M0 21.56h32V32H0V21.56Z" fill="#0052B4"></path></g></g><rect x="0.25" y="0.25" width="31.5" height="31.5" rx="15.75" stroke="#000" stroke-opacity="0.1" stroke-width="0.5"></rect><defs><clipPath id="netherlands_flag_svg__a"><rect width="32" height="32" rx="16" fill="#fff"></rect></clipPath></defs></svg> Нидерланды (Амстердам)</div>
                    </div>
                </div>

                <button type="submit" style={{ width: "100%", marginTop: 10, padding: 10, color: "#fff" }} disabled={!isValid}>{t('gtm.next')} — 
                    {payment != 1 && <><b style={{ fontWeight: 600 }}>{calculateTotal()} ₽</b> | </> }
                    <b style={{ fontWeight: 600 }}>{calculatePrice().toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')} ₽/мес</b>
                </button>
            </form>
        </MainContent>
    )
}